import React from "react";
import { ClipStatusViewModel } from "./ViewModel";
import { TrayShell } from "./Components/TrayShell";

export const ClipStatusTray = () => {
  const { entries, dismissTerminal } = ClipStatusViewModel();

  return <TrayShell entries={entries} onDismiss={dismissTerminal} />;
};
